module.exports = __webpack_public_path__ + "img/hero-home-bg.ff075a75.jpg";